<template>
  <el-dialog
    :title="`歌单信息编辑（${form.tracklistId}）`"
    :visible="visible"
    width="850px"
    center
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <el-form
      class="song-edit-from"
      ref="form"
      label-width="130px"
      inline
      :model="form"
      :rules="rules"
    >
      <section class="form-sec">
        <!-- 投诉 -->
        <template v-if="bussType === BUSS_TYPE_ENUM.COMPLAINT">
          <p class="sec-title">侵权内容信息</p>
          <span class="sub-mod">
            <el-form-item label="媒体类型">
              <el-select
                v-model="form.meidaType"
                style="width:100%"
              >
                <el-option
                  v-for="(item, key) in meidaTypeMap"
                  :key="key"
                  :value="+key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="歌曲/视频名称" prop="trackName">
              <el-input
                placeholder="请输入"
                v-model="form.trackName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="form.singerName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌曲版本">
              <el-input
                placeholder="请输入"
                v-model="form.srcVersion"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌曲专辑名">
              <el-input
                placeholder="请输入"
                v-model="form.albumName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="平台">
              <el-select
                v-model="form.appealPlat"
                style="width:100%"
              >
                <el-option
                  v-for="(item, key) in appealPlatMap"
                  :key="key"
                  :value="+key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="链接">
              <el-input
                placeholder="请输入"
                v-model="form.appealUrl"
                clearable
              ></el-input>
            </el-form-item>
          </span>
          <p class="sec-title">被侵权内容信息</p>
          <span class="sub-mod">
            <el-form-item label="歌曲ID">
              <el-input-number
                placeholder="请输入"
                v-model="form.originTrackId"
                :controls="false"
                clearable
                style="width:185px;text-align: left;"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="歌曲名" prop="originTrackName">
              <el-input
                placeholder="请输入"
                v-model="form.originTrackName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="form.originSingerName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="版本">
              <el-input
                placeholder="请输入"
                v-model="form.originSrcVersion"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑">
              <el-input
                placeholder="请输入"
                v-model="form.originAlbumName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="词作者">
              <el-input
                placeholder="请输入"
                v-model="form.originWordAuthor"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="曲作者">
              <el-input
                placeholder="请输入"
                v-model="form.originMusicAuthor"
                clearable
              ></el-input>
            </el-form-item>
          </span>
          <p class="sec-title">竞品内容信息</p>
          <span class="sub-mod">
            <el-form-item label="竞品ID">
              <el-input-number
                placeholder="请输入"
                v-model="form.competitionInfo.competitionTrackId"
                :controls="false"
                clearable
                style="width:185px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="竞品权利类型">
              <el-input
                placeholder="请输入"
                v-model="form.competitionInfo.competitionType"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="竞品权利人">
              <el-input
                placeholder="请输入"
                v-model="form.competitionInfo.competitionUser"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="竞品首次投诉日期">
              <el-date-picker
                v-model="form.competitionInfo.competitionFirstTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="竞品最新投诉日期">
              <el-date-picker
                v-model="form.competitionInfo.competitionMaxTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="竞品投诉备注">
              <el-input
                placeholder="请输入"
                v-model="form.competitionInfo.competitionRemark"
                type="textarea"
              ></el-input>
            </el-form-item>
          </span>
        </template>
        <!-- 下架 -->
        <template v-else-if="bussType === BUSS_TYPE_ENUM.OFFLINE">
          <p class="sec-title">下架歌曲信息</p>
          <span class="sub-mod">
            <el-form-item label="媒体类型">
              <el-select
                v-model="form.meidaType"
                style="width:100%"
              >
                <el-option
                  v-for="(item, key) in meidaTypeMap"
                  :key="key"
                  :value="+key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="TMEID">
              <el-input-number
                placeholder="请输入"
                v-model="form.appealTrackId"
                :controls="false"
                clearable
                style="width:185px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="歌曲/视频名称" prop="trackName">
              <el-input
                placeholder="请输入"
                v-model="form.trackName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="form.singerName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="词作者">
              <el-input
                placeholder="请输入"
                v-model="form.originWordAuthor"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="曲作者">
              <el-input
                placeholder="请输入"
                v-model="form.originMusicAuthor"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="版本">
              <el-input
                placeholder="请输入"
                v-model="form.srcVersion"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑">
              <el-input
                placeholder="请输入"
                v-model="form.albumName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="平台">
              <el-select
                v-model="form.appealPlat"
                style="width:100%"
              >
                <el-option
                  v-for="(item, key) in appealPlatMap"
                  :key="key"
                  :value="+key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="链接" style="width:640px">
              <el-input
                placeholder="请输入"
                v-model="form.appealUrl"
                clearable
                style="width:510px"
              ></el-input>
            </el-form-item>
            <el-form-item label="歌曲编码">
              <el-input
                placeholder="请输入"
                v-model="form.trackNumber"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="ISRC">
              <el-input
                placeholder="请输入"
                v-model="form.isrc"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑编码">
              <el-input
                placeholder="请输入"
                v-model="form.discNumber"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="UPC">
              <el-input
                placeholder="请输入"
                v-model="form.upc"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="曲序">
              <el-input-number
                placeholder="请输入"
                v-model="form.location"
                :controls="false"
                clearable
                style="width:185px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="专辑发行时间">
              <el-date-picker
                v-model="form.saleTime"
                type="datetime"
                placeholder="专辑发行时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:185px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="歌曲/视频别名">
              <el-input
                placeholder="请输入"
                v-model="form.originTrackName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手别名">
              <el-input
                placeholder="请输入"
                v-model="form.originSingerName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑别名">
              <el-input
                placeholder="请输入"
                v-model="form.originAlbumName"
                clearable
              ></el-input>
            </el-form-item>
          </span>
        </template>
        <!-- 白名单 -->
        <template v-else>
          <p class="sec-title">白名单歌单信息</p>
          <span class="sub-mod">
            <el-form-item label="TME ID">
              <el-input-number
                placeholder="请输入"
                v-model="form.appealTrackId"
                :controls="false"
                clearable
                style="width:185px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="歌曲名" prop="trackName">
              <el-input
                placeholder="请输入"
                v-model="form.trackName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="form.singerName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="版本">
              <el-input
                placeholder="请输入"
                v-model="form.srcVersion"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑">
              <el-input
                placeholder="请输入"
                v-model="form.albumName"
                clearable
              ></el-input>
            </el-form-item>
          </span>
          <p class="sec-title">原作品歌曲&视频信息</p>
          <span class="sub-mod">
            <el-form-item label="TME ID">
              <el-input-number
                placeholder="请输入"
                v-model="form.originTrackId"
                :controls="false"
                clearable
                style="width:185px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="歌曲名" prop="originTrackName">
              <el-input
                placeholder="请输入"
                v-model="form.originTrackName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="form.originSingerName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="词作者">
              <el-input
                placeholder="请输入"
                v-model="form.originWordAuthor"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="曲作者">
              <el-input
                placeholder="请输入"
                v-model="form.originMusicAuthor"
                clearable
              ></el-input>
            </el-form-item>
          </span>
        </template>

        <template>
          <p class="sec-title">其他信息</p>
          <span class="sub-mod">
            <el-form-item label="关联申诉单号" prop="linkId">
              <el-input
                placeholder="请输入关联申诉单号"
                disabled
                v-model="form.linkId"
              ></el-input>
            </el-form-item>

            <el-form-item label="状态" prop="tracklistStatus">
              <el-select v-model="form.tracklistStatus">
                <el-option v-for="(name, id) in tracklistStatusMap" :key="+id" :label="name" :value="+id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="权利文件" prop="rightFileList">
              <el-upload
                action="/action/upload?type=license"
                :on-remove="handleRightFileRemove"
                :on-error="handleRightFileError"
                :on-success="handleRightFileSuccess"
                :before-upload="handleRightFileBeforeUpload"
                :file-list="form.rightFileList"
                :accept="'.' + rightFileExtType.join(',.')"
              >
                <el-button size="mini" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">支持格式：{{ rightFileExtType.join(',') }}</div>
              </el-upload>
            </el-form-item>
          </span>
        </template>
      </section>
    </el-form>
    <div slot="footer" style="margin-top:30px">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script >

import {
  BUSS_TYPE_ENUM,
  TASK_TYPE_ENUM,
  bussTypeList,
  rightFileExtType,
  meidaTypeMap,
  appealPlatMap,
  tracklistStatusMap
} from '../../../const'

import { validateFileExt } from '@/utils/validate'
import { SongList } from '@/models/Complaint'

export default {
  name: 'SongEditDialog',
  props: {
    visible: Boolean,
    bussType: {
      type: Number,
      default: BUSS_TYPE_ENUM.COMPLAINT
    },
    loading: {
      type: Boolean,
      default: false
    },
    originData: {
      type: Object,
      default: () => new SongList()
    }
  },
  data() {
    return {
      BUSS_TYPE_ENUM,
      bussTypeList,
      rightFileExtType,
      meidaTypeMap,
      appealPlatMap,
      tracklistStatusMap,

      form: new SongList({}),
      rules: {}
    }
  },
  watch: {
    visible: {
      handler(v) {
        if (v) {
          this.form = new SongList(this.originData)
          if (this.form.rightFile) {
            this.form.rightFileList = [{
              ...this.form.rightFile,
              name: this.form.rightFile.fileName,
              url: this.form.rightFile.fileUrl
            }]
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    handleRightFileRemove(file, fileList) {
      this.form.rightFileList = fileList
      if (fileList.length === 0) {
        this.form.rightFile = null
      }
    },
    handleRightFileError(err, file, fileList) {
      this.form.rightFileList = fileList
      this.$message.error('授权文件上传失败: ' + err.message)
    },
    handleRightFileSuccess(resp, file, fileList) {
      file.fileUrl = file.url = resp.data.url
      file.filePath = file.path = resp.data.file_id
      file.fileName = file.name
      file.md5 = resp.data.md5

      // 处理后台数据
      this.form.rightFileList = fileList.slice(-1)
      this.form.rightFile = {
        fileName: file.name,
        fileUrl: file.url,
        md5: file.md5
      }
    },
    handleRightFileBeforeUpload(file) {
      if (!validateFileExt(['pdf'], file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      const sameFile = this.form.rightFileList.find(v => v.md5 === file.md5)
      if (sameFile) {
        this.$message.warning(`文件已存在，请检查【${file.name}】和【${sameFile.name}】`)
        return Promise.reject()
      }

      return Promise.resolve()
    },
    handleShowBatchUpload() {
      this.showBatchUpload = true
    },
    handleUpload(fileList, rightFileList) {
      const params = {
        url: fileList[0].url,
        mode: TASK_TYPE_ENUM.SONGLIST,
        complaintType: BUSS_TYPE_ENUM.COMPLAINT,
        rightFileList
      }
      this.$emit('upload', params)
    },

    handleClose() {
      if (this.loading) {
        this.$message.warning('数据提交中，请稍等！')
        return
      }
      this.form = new SongList()
      this.$emit('close')
      this.$emit('update:visible', false)
    },

    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        this.$emit('submit', this.form.getBackendData())
      } catch {
        this.$message.warning('部分信息未填写')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .song-edit-from {
    ::v-deep .el-form-item__content {
      width: 185px;
    }
    ::v-deep .el-date-editor {
      width: 100%;
    }

    .form-sec {
      padding: 12px 16px;
      background: #FAFAFB;
      border: 1px dashed rgba(0, 0, 0, 0.14);

      &:not(:last-child) {
        margin-bottom: 16px;
      }

      .sec-title {
        color: #002444;
        padding-top: 8px;
        margin-bottom: 8px;
      }
    }
}

</style>
